import { useQuery } from "react-query";
import {
  CustomModal,
  CustomView,
  Pagination,
  TableHeader,
  TableLoading,
} from "../../../../../../components";
import Context from "../../../../../../context";
import values from "../../../../../../values";
import api from "../../../../../../api";
import React, { useState } from "react";
import utils from "../../../../../../utils";
import {
  INVOICES_STATUS,
  PAY_TYPE,
  RECEIVER_TYPE,
  TRANSACTION_STATUS,
} from "../../../../../../values/dropdownItems";
import "./index.scss";
import GetUserInfo from "../../utils/getUserInfo";
import { useTranslation } from "react-i18next";

const UserInfo = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, selectedDebt } = React.useContext(
    Context.DebtsScreen
  );
  let info: { name: string; value: string }[] = [];

  info = GetUserInfo(selectedDebt);

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------

  // ?? ===========================================================================================================
  // ??                                               JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <CustomModal
      onClose={() => {
        setShowModal!("NONE");
        // setFormData({});
        // setStep(1);
      }}
      open={showModal === "SHOW_DEBT_USER_INFO"}
      minWidth={"50vw"}
      maxWidth={"55vw"}
    >
      <>
        <h6>{t("userInfo")}</h6>
        <div style={{ width: "100%" }}>
          <CustomView.Row className="form-column-row">
            {info?.map((item) => (
              <CustomView.Column medium={5} className="form-values form-column">
                <label className="form-label">{item?.name} :</label>
                <p>{item?.value}</p>
              </CustomView.Column>
            ))}
          </CustomView.Row>
        </div>
        {/* {status === "success" && data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page={page}
              totalPages={data?.result?.totalPages}
              onPaginate={(page: number) => setPage(page)}
            />
          </div>
        )} */}
      </>
    </CustomModal>
  );
};

export default UserInfo;
